module.exports = __webpack_public_path__ + "static/img/paiduitongzhi.6900d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/paiduitongzhi.png
// module id = fvfp
// module chunks = 24